import { render, staticRenderFns } from "./koejaksot-card.vue?vue&type=template&id=25dfc6c0&scoped=true&"
import script from "./koejaksot-card.vue?vue&type=script&lang=ts&"
export * from "./koejaksot-card.vue?vue&type=script&lang=ts&"
import style0 from "./koejaksot-card.vue?vue&type=style&index=0&id=25dfc6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dfc6c0",
  null
  
)

export default component.exports